import * as angular from 'angular';
import ngRedux from 'ng-redux';
import { IMailingJobService, ILoggerService } from '../../../services';
import { JobStatus, ComponentDefinition, DashboardUsers, MailingJobDefinitionDto } from '../../../models';
import { mailingJobDeleted } from '../../../common';
import { IDashboardUserActionsService, Store } from '../../../stateManagement';

class MailingJobsListController implements angular.IComponentController, angular.IOnDestroy {
    selectedItem: any;
    jobs: MailingJobDefinitionDto[];
    isLoading: boolean;
    isEditMode: boolean;
    selectItem: any;

    private _unsubscribe: () => void;
    private loadDashboardUsers: () => angular.IPromise<DashboardUsers>;

    static $inject = ['$rootScope', '$ngRedux', 'mailingJobService', 'loggerService', 'dashboardUserActionsService'];

    constructor(
        private _$rootScope: angular.IRootScopeService,
        private _$ngRedux: ngRedux.INgRedux,
        private _mailingJobService: IMailingJobService,
        private _loggerService: ILoggerService,
        private _duas: IDashboardUserActionsService
    ) {
    }

    $onInit() {
        this._unsubscribe = this._$ngRedux.connect((store: Store) => {
            return {

            };
        }, dispatch => {
            return {
                loadDashboardUsers: () => dispatch(this._duas.getAll(true))
            };
        })(this);
    }

    $onDestroy(): void {
        this._unsubscribe();
    }
    
    select(item, $event: angular.IAngularEvent) {
        this.selectItem({ item: item, event: $event });
    }

    start(definition) {
        this._mailingJobService.start(definition)
            .then(() => {
                definition.status = JobStatus.Started;
                this._loggerService.logSuccess('Mailing job started.');
            })
            .catch(() => {
                this._loggerService.logError('Failed to start mailing job.');
            });
    }

    stop(definition) {
        this._mailingJobService.stop(definition)
            .then(() => {
                definition.status = JobStatus.Stopped;
                this._loggerService.logSuccess('Mailing job stopped.');
            })
            .catch(() => {
                this._loggerService.logError('Failed to stop mailing job.');
            });
    }

    delete(guid: string): void {
        this._mailingJobService.deleteByGuid(guid)
            .then(() => {
                this._loggerService.logSuccess('Successfully deleted mailing job!');
                this._$rootScope.$broadcast(mailingJobDeleted);
                this.loadDashboardUsers();
            })
            .catch(() => {
                this._loggerService.logError('Failed to delete mailing job.');
            });
    }
}

export const wtMailingJobsList: ComponentDefinition = {
    componentId: 'wtMailingJobsList',
    controller: MailingJobsListController,
    template: require('./mailingJobsList.component.html'),
    controllerAs: 'vm',
    bindings: {
        selectedItem: '=',
        jobs: '<',
        isLoading: '=',
        isEditMode: '=',
        selectItem: '&'
    }
};